<template>
    <div>
        <svg v-if="!view" @click.prevent="view = true" class="text-blue-700 cursor-pointer ml-2 w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"></path></svg>

        <div v-if="view" class="fixed z-10 inset-0 overflow-y-auto">
                <div class="flex outturns-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                    <div class="fixed inset-0 transition-opacity" aria-hidden="true" @click="view = false">
                        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                    </div>

                    <!-- This element is to trick the browser into centering the modal contents. -->
                    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
                    <div class="inline-block align-bottom bg-white rounded-lg  text-left overflow-hidden shadow-xl transform transition-all ease-out duration-300 sm:my-8 sm:align-middle sm:max-w-3xl sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
                        <div class="flex justify-between outturns-center mb-4 bg-blue-50 border-b border-blue-100 p-4">
                            <p class="text-xl font-semibold text-blue-900">Outturn Recap</p>
                            <svg @click="view = false" class="w-6 h-6 text-gray-400 cursor-pointer hover:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                        </div>
                        <div class="px-4 pt-5 pb-4 sm:p-6 lg:grid lg:grid-cols-12 lg:gap-x-8">
                            <section class="lg:col-span-4">
                                <div class="px-6 py-4 bg-blue-50 mb-6">
                                    <div class="text-gray-900 text-2xl mb-1 font-mono font-medium">{{ outturn.recap_number  }}</div>
                                    <div class="text-xs font-medium text-gray-500 uppercase tracking-wider">Recap Number</div>
                                </div>
                                <div class="px-6 py-4 bg-blue-50 mb-6">
                                    <div class="text-gray-900 text-2xl mb-1 font-mono font-medium">{{ outturn.lab_ident }}</div>
                                    <div class="text-xs font-medium text-gray-500 uppercase tracking-wider">Certificate Number</div>
                                </div>
                            </section>
                            <section class="lg:col-span-8">
                                <div class="bg-white pt-6 shadow sm:rounded-md sm:overflow-hidden">
                                <div class="px-4 sm:px-6">
                                    <h2 class="text-lg leading-6 font-medium text-gray-900">Details</h2>
                                </div>
                                <div class="mt-6 flex flex-col">
                                    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                                            <div class="overflow-hidden border-t border-gray-200">
                                                <table class="min-w-full divide-y divide-gray-200">
                                                    <tbody class="bg-white divide-y divide-gray-200">
                                                    <tr>
                                                        <td class="bg-gray-50 px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Foreign Matter
                                                        </td>
                                                        <td class="px-6 py-4 text-right whitespace-nowrap text-sm text-gray-500 font-mono">
                                                            {{ outturn.foreign_matter_percent  }}%
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="bg-gray-50 px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Moisture
                                                        </td>
                                                        <td class="px-6 py-4 text-right whitespace-nowrap text-sm text-gray-500 font-mono">
                                                            {{ outturn.moisture_percent  }}%
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="bg-gray-50 px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Free Fatty Acids
                                                        </td>
                                                        <td class="px-6 py-4 text-right whitespace-nowrap text-sm text-gray-500 font-mono">
                                                            {{ outturn.free_fatty_acid_percent }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="bg-gray-50 px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Oil
                                                        </td>
                                                        <td class="px-6 py-4 text-right whitespace-nowrap text-sm text-gray-500 font-mono">
                                                            {{ outturn.oil_percent }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="bg-gray-50 px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Ammonia
                                                        </td>
                                                        <td class="px-6 py-4 text-right whitespace-nowrap text-sm text-gray-500 font-mono">
                                                            {{ outturn.ammonia_percent }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="bg-gray-50 px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Pay Grade
                                                        </td>
                                                        <td class="px-6 py-4 text-right whitespace-nowrap text-sm text-gray-500 font-mono">
                                                            {{ outturn.grade_percent }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="bg-gray-50 px-6 py-4 whitespace-nowrap text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                            Actual Grade
                                                        </td>
                                                        <td class="px-6 py-4 text-right whitespace-nowrap text-sm text-gray-500 font-mono">
                                                            {{ outturn.cake_pounds }}
                                                        </td>
                                                    </tr>

                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>

    </div>
</template>

<script>

export default {
    props: {
        outturn: {
            type: Object,
            required: true,
            defualt: {}
        }
    },
    data() {
        return {
            view: false,
        }
    },
}
</script>
